module.exports = __webpack_public_path__ + "static/img/index_non-vip.53f60fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/Christmas2020/index_non-vip.png
// module id = CqtA
// module chunks = 1